import i18n from "../i18n";

export const APP_LANGUAGE_STORAGE_KEY = "I18N_LANGUAGE";
export const DEFAULT_APP_LANGUAGE = "en";

/** Roles that use English-only UI (shared i18n components still resolve in English). */
export const ROLES_FORCE_ENGLISH = new Set(["admin", "subAdmin", "client"]);

export function getStoredAppLanguage() {
  return localStorage.getItem(APP_LANGUAGE_STORAGE_KEY) || DEFAULT_APP_LANGUAGE;
}

export function setAppLanguage(lang) {
  const next = lang || DEFAULT_APP_LANGUAGE;
  if (i18n.language !== next) {
    i18n.changeLanguage(next);
  }
  localStorage.setItem(APP_LANGUAGE_STORAGE_KEY, next);
}

export function forceEnglishLanguage() {
  setAppLanguage(DEFAULT_APP_LANGUAGE);
}

export function shouldForceEnglishForRole(role) {
  return ROLES_FORCE_ENGLISH.has(role);
}
